import './styles/metadata-view.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'

export default class MetadataView extends React.Component {
  static propTypes = {
    title:    PropTypes.string.isRequired,
    metadata: PropTypes.object.isRequired,    
  }

  render() {
    const { metadata, title } = this.props

    const keys = Object.keys(metadata).sort()
    const hide = keys.length === 0

    const className = classnames('metadata-view', { hide })

    return (
      <div className={className}>
        <div className="tite">{ title }</div>

        <div className="content">
          {
            keys.map((key) => {
              const value = metadata[key]

              return (              
                <div key={key} className="ui mini message">
                  <div className="title">{ key }</div>
                  <div className="message">{ value }</div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}
